const { default: CommonServices } = require("./common/common");

class MCQManagementService extends CommonServices {
  constructor() {
    // Base collection for chapters
    super("/chapters");
    this.subResource = "questions";
  }

  // helper to create nested service under a chapter
  buildNested(chapterId) {
    return new CommonServices(`${this.url}/${chapterId}/${this.subResource}`);
  }

  // 1) GET chapters/:chapterId/questions
  async getAllByChapter(chapterId, params) {
    const nested = this.buildNested(chapterId);
    return nested.getAll(params);
  }

  // 2) GET chapters/:chapterId/questions/:mcqId
  async getByIdUnderChapter(chapterId, mcqId) {
    const nested = this.buildNested(chapterId);
    return nested.getById(mcqId);
  }

  // 3) PUT chapters/:chapterId/questions/:mcqId
  async updateUnderChapter(chapterId, mcqId, data) {
    const nested = this.buildNested(chapterId);
    return nested.updateById(mcqId, data);
  }

  // POST chapters/:chapterId/questions
  async create(chapterId, data) {
    const nested = this.buildNested(chapterId);
    return nested.createOne(data);
  }

  // Optional: DELETE chapters/:chapterId/questions/:mcqId
  async deleteUnderChapter(chapterId, mcqId) {
    const nested = this.buildNested(chapterId);
    return nested.deleteById(mcqId);
  }
}

const mcqManagementService = new MCQManagementService();
export default mcqManagementService;